import React, { useEffect, useRef, useState } from 'react';
import { Facebook, Mail } from 'lucide-react';
import gsap from 'gsap';

const Footer: React.FC = () => {
  const statusRef = useRef<HTMLDivElement>(null);
  const [showEmail, setShowEmail] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gsap.fromTo(statusRef.current,
              { scale: 0.8, opacity: 0 },
              { scale: 1, opacity: 1, duration: 0.8, ease: "elastic.out(1, 0.5)" }
            );
            observer.disconnect();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (statusRef.current) {
        observer.observe(statusRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <footer className="relative p-6 pb-12 md:pb-12 border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-900/50 overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        
        {/* Main Stack: Socials -> Status -> Copyright */}
        <div className="flex flex-col items-center space-y-4">
          
          {/* Social Icons - Topmost */}
          <div className="flex items-center space-x-4">
            <a 
              href="https://www.facebook.com/share/18BtSCswVk/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center justify-center p-2 rounded-full border border-slate-300 dark:border-slate-700 hover:border-primary hover:text-primary transition-all duration-300 bg-white dark:bg-slate-800 shadow-sm hover:shadow-primary/20"
              aria-label="Facebook"
            >
              <Facebook size={18} />
            </a>
            
            <button 
              onClick={() => setShowEmail(!showEmail)}
              className={`flex items-center justify-center p-2 rounded-full border transition-all duration-300 bg-white dark:bg-slate-800 shadow-sm hover:shadow-primary/20 ${showEmail ? 'border-primary text-primary' : 'border-slate-300 dark:border-slate-700 hover:border-primary hover:text-primary'}`}
              aria-label="Email"
            >
              <Mail size={18} />
            </button>
          </div>

          {/* Conditional Email Display */}
          {showEmail && (
            <div className="animate-in fade-in slide-in-from-top-1 duration-300">
              <a 
                href="mailto:staroadtouring@gmail.com" 
                className="font-mono text-[10px] md:text-xs text-primary font-bold tracking-widest hover:underline"
              >
                staroadtouring@gmail.com
              </a>
            </div>
          )}

          {/* Stage Ready Status */}
          <div 
            ref={statusRef}
            className="flex items-center space-x-2 px-3 py-1 rounded-full border border-slate-300 dark:border-slate-700 bg-background-light dark:bg-background-dark opacity-0"
          >
            <span className="w-1.5 h-1.5 bg-green-500 rounded-full animate-pulse shadow-[0_0_5px_rgba(34,197,94,0.6)]"></span>
            <span className="text-[9px] font-mono font-bold uppercase tracking-tighter text-slate-600 dark:text-slate-400">
              STAGE READY: 99.9%
            </span>
          </div>

          {/* Copyright Text */}
          <div className="text-[10px] font-mono text-slate-600 dark:text-slate-500 uppercase tracking-widest text-center">
            © 2026 STARROAD TOURING. ALL RIGHTS RESERVED.
          </div>
          
        </div>

      </div>
    </footer>
  );
};

export default Footer;